import React from "react";
import { useSelector } from "react-redux";

import { components } from "../components";
import { Routes, TabScreens } from "../routes";
import { RootState } from "../store";

import { hooks } from "../hooks";
import { Favorite } from "../screens/tabs/Favorite";
import { Home } from "../screens/tabs/Home";
import { Menu } from "../screens/tabs/Menu";
import { Notification } from "../screens/tabs/Notification";
import { Order } from "../screens/tabs/Order";

export const TabNavigator: React.FC = () => {

   const dataParam = sessionStorage.getItem("dataParam");

  // Show only Onboarding screen if dataParam is not present
  if (!dataParam) {
    window.location.replace("/")
  }
  const currentTabScreen = useSelector(
    (state: RootState) => state.tabSlice.screen
  );
  const { dishesLoading, getConfiguration } = hooks.useGetConfiguration();
  const renderTitle = (): string => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return "";
      case TabScreens.Menu:
        return "";
      case TabScreens.Order:
        return "Order";
      case TabScreens.Favorite:
        return "Favorite";
      case TabScreens.Notification:
        return "Notification";
      default:
        return "Home";
    }
  };

  const renderScreens = (): JSX.Element | null => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return <Home />;
      case TabScreens.Menu:
        return <Menu />;
      case TabScreens.Order:
        return <Order />;
      case TabScreens.Favorite:
        return <Favorite />;
      case TabScreens.Notification:
        return <Notification />;
      default:
        return null;
    }
  };

  const renderUserPhoto = (): boolean => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return true;
      case TabScreens.Menu:
        return true;
      case TabScreens.Order:
        return true;
      case TabScreens.Favorite:
        return true;
      case TabScreens.Notification:
        return true;
      default:
        return false;
    }
  };

  const renderUserName = (): boolean => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return true;
      case TabScreens.Menu:
        return true;
      case TabScreens.Order:
        return false;
      case TabScreens.Favorite:
        return false;
      case TabScreens.Notification:
        return false;
      default:
        return false;
    }
  };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showBasket={true}
        title={renderTitle()}
        userName={renderUserName()}
        userPhoto={renderUserPhoto()}
      />
    );
  };

  const renderFooter = (): JSX.Element => {
    return <components.Footer />;
  };

  const renderLoader = (): JSX.Element | null => {
    if (dishesLoading) {
      return <components.Loader />;
    }
    return null;
  };

  const navigate = hooks.useNavigate();

  const renderFloatingAIButton = (): JSX.Element => {
    return (
      <button
        onClick={() => navigate(Routes.QuestionFlow)}
        style={{
          position: 'fixed',
          bottom: getConfiguration?.isOrderFromAppSupported ? '80px' : '20px',
          right: '20px',
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          backgroundColor: 'var(--main-turquoise)',
          border: 'none',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)';
        }}
        aria-label="AI Assistant - What should I eat?"
      >
        <span 
          style={{ 
            fontSize: '24px',
            lineHeight: '1',
            display: 'block',
          }} 
        >
          🍽️
        </span>
      </button>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: 'var(--main-background)',
      }}
    >
      {renderHeader()}
      <div
        style={{
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {renderScreens()}
      </div>
      {getConfiguration?.isOrderFromAppSupported ? renderFooter() : null}
      {renderFloatingAIButton()}
      {renderLoader()}
    </div>
  );
};
